import { useTheme } from '@mui/material'

import { IconProps } from '@f-fertighaus/applications/Next/types/icon'

export const AngleIcon = (props: IconProps) => {
  const theme = useTheme()
  const stroke = props.color || theme.palette.primary.main
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_414_1682)'>
        <path
          d='M8.8557 14.9818C8.80059 13.9611 8.58581 12.9936 8.17127 12.0575C7.85441 12.1984 7.54945 12.3336 7.2614 12.4614C7.39603 12.8947 7.54569 13.2955 7.64275 13.7094C7.73919 14.1208 7.78177 14.5447 7.8494 14.973H1.37764C2.00697 12.874 2.63317 10.7882 3.26312 8.68852C3.49294 8.79309 3.70897 8.88389 3.91812 8.98847C4.52679 9.2928 5.08035 9.67979 5.58945 10.1494C5.82427 9.90021 6.05158 9.65787 6.28954 9.40551C5.48237 8.65345 4.57188 8.10177 3.55556 7.7129C4.30011 5.23002 5.03902 2.76656 5.78044 0.294329C5.44041 0.192259 5.12418 0.0970766 4.79981 -0.000610352C3.19737 5.34211 1.59931 10.6686 0 16H15.5122V14.9818H8.8557Z'
          fill={stroke}
        />
        <path
          d='M11.166 11.914C12.1617 11.9178 12.967 11.1144 12.9639 10.1219C12.9607 9.13058 12.1661 8.33719 11.1761 8.33594C10.1879 8.33531 9.38825 9.13246 9.38575 10.12C9.38324 11.1075 10.1804 11.9109 11.166 11.914ZM11.171 9.35664C11.585 9.35288 11.9375 9.7023 11.9419 10.12C11.9463 10.5383 11.6012 10.8846 11.1786 10.8864C10.7527 10.8883 10.4133 10.5533 10.4121 10.1281C10.4108 9.70543 10.7496 9.3604 11.171 9.35664Z'
          fill={stroke}
        />
        <path
          d='M6.80161 11.6223C7.06524 11.4607 7.32135 11.3035 7.57747 11.1464C7.60377 11.1301 7.62756 11.1113 7.6714 11.08C7.45849 10.7813 7.25497 10.4945 7.04207 10.1958C6.76591 10.4206 6.50667 10.6316 6.24805 10.842C6.43966 11.1119 6.61876 11.3643 6.80161 11.6223Z'
          fill={stroke}
        />
      </g>
      <defs>
        <clipPath id='clip0_414_1682'>
          <rect width='15.5122' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
